module.exports = __webpack_public_path__ + "static/media/italic.4e2165a7.svg";